class EditorialPanoramic extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['image', 'overlay']
  }

  connectedCallback () {
    super.connectedCallback()

    this.updateDim()
  }

  setupListeners () {
    super.setupListeners()

    this.updateDim = this.updateDim.bind(this)

    this.listeners.add(window, 'scroll', this.updateDim, { passive: true })
    this.listeners.add(window, 'resize', this.updateDim, { passive: true })
  }

  updateDim () {
    const imageEl = this.els.image?.element
    const overlayEl = this.els.overlay?.element
    const nextEl = this.sectionWrapper?.nextElementSibling

    if (!imageEl || !overlayEl) return

    if (this.maxDim === 0 || !nextEl) {
      overlayEl.style.opacity = '0'
      return
    }

    const imageHeight = imageEl.offsetHeight
    if (imageHeight === 0) {
      overlayEl.style.opacity = '0'
      return
    }

    const nextTop = nextEl.getBoundingClientRect().top
    const uncovered = Math.max(0, Math.min(imageHeight, nextTop))
    const progress = 1 - uncovered / imageHeight

    overlayEl.style.opacity = String(progress * this.maxDim)
  }

  get sectionWrapper () {
    return this.closest('.shopify-section')
  }

  get maxDim () {
    const raw = parseFloat(this.dataset.maxDim)

    if (Number.isNaN(raw)) return 0.3

    return raw > 1 ? raw / 100 : raw
  }
}

if (!customElements.get('editorial-panoramic')) {
  customElements.define('editorial-panoramic', EditorialPanoramic)
}
